import { useCallback as f } from "react";
import { assignRef as n } from "./index177.mjs";
function t(...e) {
  return (r) => {
    e.forEach((o) => n(o, r));
  };
}
function m(...e) {
  return f(t(...e), e);
}
export {
  t as mergeRefs,
  m as useMergedRef
};
